import { Component, Signal, computed, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBar } from "@angular/material/progress-bar";
import { TranslocoModule } from "@ngneat/transloco";

/** El countdown lo calcula `SesionActivaService`; el diálogo solo lo muestra. */
export interface SesionActivaDialogData {
  segundosRestantes: Signal<number>;
  totalSegundos: number;
}

@Component({
  selector: "app-sesion-activa",
  standalone: true,
  templateUrl: "./sesion-activa.component.html",
  styleUrls: ["./sesion-activa.component.scss"],
  imports: [
    TranslocoModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIcon,
    MatProgressBar,
  ],
})
export class SesionActivaComponent {
  public data: SesionActivaDialogData = inject(MAT_DIALOG_DATA);

  private readonly dialogRef = inject(MatDialogRef<SesionActivaComponent>);

  public readonly progreso = computed<number>(() =>
    this.data.totalSegundos
      ? (this.data.segundosRestantes() / this.data.totalSegundos) * 100
      : 0,
  );

  constructor() {
    // Aviso con cuenta regresiva: queda centrado y chico en mobile, fuera del
    // fullscreen global de diálogos.
    this.dialogRef.addPanelClass("dialog-compact-mobile");
  }

  public continuar(): void {
    this.dialogRef.close(true);
  }
}
